import React from "react";
import { PURCHASE_ORDER, SUPPLIERS } from "../../../constants/route-paths";
import { withRouter } from "../../../util/with-router";
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import ViewPurchaseOrderComponent from '../../../components/po/view'
import { Button } from "react-bootstrap";

function ViewPurchaseOrder(props) {

  const cancelHandler = () => {
    props.history(`/${SUPPLIERS}/${PURCHASE_ORDER}`);
  };

  return (
    <div className="purchase-order-block" data-cy="view-purchase-order">
      <h2 className="content-heading text-uppercase" data-cy="heading">View Purchase Order</h2>
      <div className="col-12 breadcrumb-block p-0" data-cy="breadcrumb">
        <Breadcrumb>
          <Breadcrumb.Item onClick={cancelHandler} data-cy="purchase-order">Purchase Order</Breadcrumb.Item>
          <Breadcrumb.Item active data-cy="view-purchase-order">View Purchase Order</Breadcrumb.Item>
        </Breadcrumb>

      </div>

      <ViewPurchaseOrderComponent
        poId={props.params.poId}
      />

      <div className="col-12 d-flex mt-3 justify-content-end">
        <Button type="submit" onClick={cancelHandler} className="secondarybtn cancelbtn" data-cy="cancel-button">CANCEL</Button>
      </div>
    </div>
  );
}

export default withRouter(ViewPurchaseOrder);
